import { useEffect, useState } from "react";
import Mytitle from "../../Components/Mytitle";
import ModalForm from "../../Components/ModalForm";
import MyInput from "../../Components/Myinput";
import API from "../../Api/axiosConfig";
import { toast } from "react-toastify";
import MyButton from "../../Components/MyButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import Can from "../../Components/Can";
import MyTable from "../../Components/MyTable";

function DiscountReward() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    employee_id: "",
    type: "",
    date: new Date().toISOString().split("T")[0],
    value: "",
    note: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [editId, setEditId] = useState(null);

  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [employees, setEmployees] = useState([]);

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  useEffect(() => {
    API.get("/employees")
      .then((res) => {
        setEmployees(res.data.data || []);
      })
      .catch((err) => {
        console.error(err);
        toast.error("فشل تحميل الموظفين");
      });
  }, []);
  const handleShowDetails = (employee) => {
    setSelectedEmployee(employee);
    setShowDetailsModal(true);
    // console.log(employee);
  };
  const handleAdd = () => {
    setFormData({
      employee_id: "",
      type: "",
      date: new Date().toISOString().split("T")[0],
      value: "",
    });
    setEditId(null);
    setErrors({});
    setShowModal(true);
  };

  const handleEdit = (record) => {
    setFormData({ ...record });
    setEditId(record.uuid);
    setErrors({});
    setShowModal(true);
  };

  const handleDeleteClick = (uuid) => {
    setDeleteId(uuid);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setDeleting(true);
    try {
      await API.delete(`/discount-reward/${deleteId}`);
      console.log("تم حذف السجل بنجاح");
      setRefreshKey((prev) => prev + 1);
      setShowDeleteModal(false);
      setDeleteId(null);
    } catch (err) {
      console.error(err);
      toast.error("فشل الحذف");
    } finally {
      setDeleting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      if (editId) {
        await API.put(`/discount-reward/${editId}`, formData);
        console.log("تم تعديل السجل بنجاح");
      } else {
        await API.post("/discount-reward", formData);
        console.log("تم إضافة السجل بنجاح");
      }
      setShowModal(false);
      setRefreshKey((prev) => prev + 1);
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      }
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { header: "الموظف", accessor: "employee.name" },
    {
      header: "النوع",
      accessor: (row) => (row.type === "discount" ? "خصم" : "مكافأة"),
    },
    { header: "التاريخ", accessor: "date" },
    { header: "القيمة", accessor: "value" },
    {
      header: "الإجراءات",
      accessor: (row) => (
        <>
          <Can permission="empAdjustment_show">
            <button
              className="btn btn-sm mx-1 extrabtn"
              title="عرض التفاصيل"
              onClick={() => handleShowDetails(row)}>
              <FontAwesomeIcon icon={faEye} color="white" />
            </button>
          </Can>
          <Can permission="empAdjustment_update">
            <button
              className="btn btn-sm btn-primary mx-1 no-style"
              onClick={() => handleEdit(row)}>
              <FontAwesomeIcon icon={faPen} />
            </button>
          </Can>

          <Can permission="empAdjustment_delete">
            <button
              className="btn btn-sm btn-danger no-style"
              onClick={() => handleDeleteClick(row.uuid)}>
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </Can>
        </>
      ),
      hideOnPrint: true,
    },
  ];

  return (
    <div className="container mt-5">
      <Mytitle title="عمولات و خصومات" />
      {/* <Can permission="empAdjustment_create">
                <MyButton
                    text="إضافة خصم / عمولة"
                    variant="success"
                    type="button"
                    className="mb-3"
                    onClick={handleAdd}
                />
            </Can> */}

      <ModalForm
        show={showModal}
        onClose={() => setShowModal(false)}
        title={editId ? "تعديل السجل" : "إضافة خصم / عمولة"}
        onSubmit={handleSubmit}
        loading={loading}
        mode="form">
        <MyInput
          // label="الموظف"
          as="select"
          value={formData.employee_id}
          onChange={(e) =>
            setFormData({ ...formData, employee_id: e.target.value })
          }
          error={errors.employee_id?.[0]}
          options={[
            { value: "", label: "اختر الموظف" },
            ...employees.map((emp) => ({
              value: emp.id,
              label: emp.name,
            })),
          ]}
        />
        <MyInput
          // label="النوع"
          value={formData.type}
          onChange={(e) => setFormData({ ...formData, type: e.target.value })}
          error={errors.type?.[0]}
          as="select"
          options={[
            { value: "", label: "اختر النوع" },
            { value: "discount", label: "خصم" },
            { value: "reward", label: "عمولة" },
          ]}
        />
        <MyInput
          label="التاريخ"
          type="date"
          value={formData.date}
          onChange={(e) => setFormData({ ...formData, date: e.target.value })}
          error={errors.date?.[0]}
        />
        <MyInput
          label="القيمة"
          type="number"
          value={formData.value}
          onChange={(e) => setFormData({ ...formData, value: e.target.value })}
          error={errors.value?.[0]}
        />
        <MyInput
          label="الملاحطات"
          value={formData.note}
          onChange={(e) => setFormData({ ...formData, note: e.target.value })}
          error={errors.note?.[0]}
        />
      </ModalForm>

      <ModalForm
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title="تأكيد الحذف"
        onSubmit={confirmDelete}
        loading={deleting}
        mode="confirm"
        confirmText="حذف"
        cancelText="إلغاء">
        هل أنت متأكد أنك تريد حذف هذا السجل؟
      </ModalForm>
      <ModalForm
        show={showDetailsModal}
        onClose={() => setShowDetailsModal(false)}
        title={`تفاصيل الفاتورة`}
        mode="print">
        {selectedEmployee ? (
          <>
            {selectedEmployee && (
              <div className="container text-end">
                <h5 className="text-center mb-5 ">
                  عمولات و خصومات ({selectedEmployee.id})
                </h5>
                <div className="row mb-3">
                  <div className="col-6 mb-3">
                    <strong>اسم الموظف:</strong>{" "}
                    {selectedEmployee.employee.name}
                  </div>
                  <div className="col-6 mb-3">
                    <strong>النوع:</strong>{" "}
                    {selectedEmployee.type === "reward" ? "مكافأة" : "خصم"}
                  </div>
                  <div className="col-6 mb-3">
                    <strong>القيمة:</strong> {selectedEmployee.value} جنيه
                  </div>
                  <div className="col-6 mb-3">
                    <strong>الملاحظة:</strong> {selectedEmployee.note || "—"}
                  </div>
                  <div className="col-12 mb-3 text-end">
                    <strong>التاريخ:</strong> {selectedEmployee.date}
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          // <table className="table table-bordered">
          //   <thead>
          //     <tr>
          //       <th>التاريخ</th>
          //       <th>الموظف</th>
          //       <th>رقم الهاتف</th>
          //       <th>النوع</th>
          //       <th>القيمة</th>
          //       <th>الوصف</th>
          //     </tr>
          //   </thead>
          //   <tbody>
          //     <tr>
          //       <td>{selectedInvoice.date}</td>
          //       <td>{selectedInvoice.employee?.name}</td>
          //       <td>{selectedInvoice.employee?.phone}</td>
          //       <td>
          //         {selectedInvoice.cash_type === "cash"
          //           ? "نقدي"
          //           : selectedInvoice.cash_type === "bank"
          //           ? "تحويل بنكي"
          //           : "-"}
          //       </td>
          //       <td>{selectedInvoice.value}</td>
          //       <td>{selectedInvoice.description || "-"}</td>
          //     </tr>
          //   </tbody>
          // </table>
          <p>لا توجد بيانات متاحة.</p>
        )}
      </ModalForm>
      <MyTable
        resource="discount-reward"
        columns={columns}
        refreshKey={refreshKey}
        title={"الخصومات والعمولات"}
        filters={[
          { type: "text", name: "employee.name", label: "بحث باسم الموظف" },
          {
            type: "select",
            name: "type",
            label: "النوع",
            options: [
              { value: "", label: "الكل" },
              { value: "reward", label: "مكافئة" },
              { value: "discount", label: "خصم" },
            ],
          },
        ]}
        dateFilter={{ field: "created_at", label: "تاريخ الإنشاء" }}
        button={{
          text: "إضافة خصم / عمولة",
          onClick: handleAdd,
          variant: "success",
          permission: "empAdjustment_create",
        }}

        // appendData={true}
      />
    </div>
  );
}

export default DiscountReward;
